<template>
  <div class="w-full">


    <div class="flex justify-between w-full">

      <div class="">
        <SelectButton v-model="restaurantPlace"
                      :options="RESTAURANT_PLACES"
                      aria-labelledby="basic"
                      size="small"
                      option-value="value"
                      optionLabel="name"
        />
      </div>
      <Button @click="addNewMealExtra" size="small" label="Pridať" icon="pi pi-plus" iconPos="right"/>
    </div>

    <hr class="my-4">

    <div class="grid grid-cols-4 mt-5 gap-4">

      <MealExtraCard v-for="(item,i) in filteredList"
                     :key="item.id"
                     :data="item"
                     :restaurantPlace="restaurantPlace"
      />

    </div>

  </div>
</template>

<script setup>
import {ref, reactive, watch, computed} from "vue";
import {RESTAURANT_PLACES} from "@/content/lists.js";
import useContentStore from "@/stores/contentStore.js";
import MySelect from "@/components/inputs/MySelect.vue";
import MealExtraCard from "@/components/views/MealExtraCard.vue"
import Supabase from "@/utils/Supabase.js"

const restaurantPlace = ref('BO')

const EMPTY_MEAL_EXTRA = () => ({
  name: '',
  title: '',
  subTitle: '',
  restaurantPlace: restaurantPlace.value,
  items: [
    {
      appProductId: null,
    }
  ]
})

const addNewMealExtra = () => contentStore.mealsExtras.push({...EMPTY_MEAL_EXTRA()})

const contentStore = useContentStore()
const filteredList = computed(() => contentStore.mealsExtrasList[restaurantPlace.value] ?? [])

console.log('filteredList', filteredList)

</script>